import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { updatePayoutsInfo } from '@/modules/partner/actions/async/updatePayoutsInfo';
import { AppDispatch } from '@/root-store';
import { StepLayout } from '@/shared/view/StepLayout';

import { PayoutsInfoEditForm } from './form';
import { PayoutsCompanyEditForm } from './FormCompany';

interface Props {
  onGoBack: () => unknown;
  isCompany?: boolean;
}

const messages = {
  companyTitle: {
    defaultMessage: 'Company info',
    id: 'ZKvp6f',
    description: 'Profile screen: subheader',
  },
  defaultTitle: {
    defaultMessage: 'Tax Information',
    id: 'edit_tax_info_title',
    description: 'Edit payouts screen: title',
  },
};

const EditPayouts = ({ onGoBack, isCompany }: Props) => {
  const dispatch = useDispatch() as AppDispatch;
  const intl = useIntl();

  const postForm = useCallback(
    async (formValues: Omit<Parameters<typeof updatePayoutsInfo>[0], 'isCompany'>) => {
      const resultAction = await dispatch(updatePayoutsInfo({ ...formValues, isCompany }));

      if (updatePayoutsInfo.fulfilled.match(resultAction)) {
        const { isSucceed, result = {} } = resultAction.payload;

        if (isSucceed && !result.validationErrors && !result.baseErrors) {
          onGoBack();
        }

        return result;
      }

      return {};
    },
    [dispatch, onGoBack, isCompany],
  );

  return (
    <StepLayout
      onClickBack={onGoBack}
      hideProgress={true}
      title={intl.formatMessage(isCompany ? messages.companyTitle : messages.defaultTitle)}
    >
      {isCompany ? (
        <PayoutsCompanyEditForm onSubmit={postForm} />
      ) : (
        <PayoutsInfoEditForm onSubmit={postForm} />
      )}
    </StepLayout>
  );
};

export { EditPayouts };
